import React from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { Row, Select, DatePicker, Space } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../../Hooks";

import { ReactComponent as ArrowDown } from "../../../../assets/images/down-arrow.svg";

import "./style.scss";

const options = [
  {
    id: 1,
    Value: "day",
    EnglishName: "Day",
    ArabicName: "يوم",
  },
  {
    id: 2,
    Value: "week",
    EnglishName: "Week",
    ArabicName: "أسببوع",
  },
  {
    id: 3,
    Value: "month",
    EnglishName: "Month",
    ArabicName: "شهر",
  },
];

const CalendarToolbar = ({
  toolbar,
  data,
  view,
  setView,
  selectedDate,
  setSelectedDate,
  setSelectedDateEvents,
}) => {
  const [isAr] = useIsAr();

  const goToBack = () => {
    switch (toolbar.view) {
      case "day":
        toolbar.date.setDate(toolbar.date.getDate() - 1);
        break;
      case "week":
        toolbar.date.setDate(toolbar.date.getDate() - 7);
        break;
      default:
        toolbar.date.setMonth(toolbar.date.getMonth() - 1);
    }
    toolbar.onNavigate("prev");
  };

  const goToNext = () => {
    switch (toolbar.view) {
      case "day":
        toolbar.date.setDate(toolbar.date.getDate() + 1);
        break;
      case "week":
        toolbar.date.setDate(toolbar.date.getDate() + 7);
        break;
      default:
        toolbar.date.setMonth(toolbar.date.getMonth() + 1);
    }
    toolbar.onNavigate("next");
  };

  return (
    <Row justify="between" align="center" className="wrapper">
      <div className="select--view-wrapper" />

      <div className="calendar-toolbar">
        <button onClick={goToBack}>
          <ArrowDown
            className={isAr ? "arrow left" : "arrow right"}
            style={{ fill: "gray" }}
          />
        </button>
        <label className={isAr ? "rtl" : "ltr"}>{toolbar.label}</label>
        <button onClick={goToNext}>
          <ArrowDown
            className={isAr ? "arrow right" : "arrow left"}
            style={{ fill: "gray" }}
          />
        </button>
      </div>
      <Space style={{ zIndex: 9999 }}>
        <div className="select--view-wrapper">
          <Select
            options={options}
            placeholder={<FormattedMessage id="common.select" />}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.Value}
            onChange={(item) => {
              setView(item.Value);
            }}
            value={options.find((e) => e.Value === view)}
          />
        </div>

        <DatePicker
          onChange={(e) => {
            setSelectedDate(e);

            const events = data.filter((event) =>
              moment(e)
                .startOf("day")
                .isSame(moment(event.StartDate).startOf("day"))
            );

            setSelectedDateEvents(events);
          }}
          value={selectedDate}
        />
      </Space>
    </Row>
  );
};

export default CalendarToolbar;
